import React from "react";
import {
  Backdrop,
  Button,
  Toolbar,
  Container,
  Typography,
} from "@mui/material";
import { useGetAllMappingsQuery } from "../../Store/Services/BrPrivService";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { openAddBrPrivModal } from "../../Store/Slices/brPrivSlice";
import SearchBar from "../../Components/Shared/SearchBar";
import BrPrivTable from "../../Components/BrPrivMapping/BrPrivTable";
import BrPrivDialog from "../../Components/BrPrivMapping/BrPrivDialog";
import { useEffect } from "react";
import styles from "./Management.module.css";

const MappingManagement = () => {
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState([]);
  const [roles, setRoles] = useState("");

  useEffect(() => {
    const getRoles = () => {
      if (typeof window !== undefined) {
        setRoles(sessionStorage.getItem("role"));
      }
    };
    getRoles();
  }, []);

  const { data: brPriv, isSuccess, isLoading } = useGetAllMappingsQuery();

  return (
    <>
      {roles?.split(",").includes("PRIV_ECOM_MAPPINGDISPLAY") && (
        <div className={styles.pageContainer}>
          <div>
            <Toolbar className={styles.subNavBar}>
              <Typography className={styles.topic}>Mapping Management</Typography>

              {roles?.split(",").includes("PRIV_ECOM_ADDMAPPING") && (

                <Button
                onClick={() => dispatch(openAddBrPrivModal())}
                  variant="contained"
                  color="primary"
                  className={styles.buttonItem}
                  aria-label="Add New Mapping"
                >
                  Add New
                </Button>
              )}
            </Toolbar>
          </div>

            <Container>
              {!isLoading && (
                <SearchBar
                  data={brPriv || []}
                  setSearchData={setSearchData}
                  text="Search Role"
                  search="brPriv"
                />
              )}
            </Container>

            <Container>
              <BrPrivTable data={searchData} />
            </Container>

          <BrPrivDialog />
        </div>
      )}
    </>
  );
};

export default MappingManagement;
